import { TUser } from 'src/redux/services/users';

export const getDisplayName = (user: TUser, withOutId?: boolean) => {
  const name = user
    ? user.given_name ?? user.nickname ?? (withOutId ? '' : `c id: ${user.id}`)
    : '';
  return name;
};
